/*
 * $Id:: model.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { me as meSlice } from '../AuthenticatedPage/authenticationSlice';
import { SLICE_NAME } from './constants';
import { fetchUsersPaginated, impersonateUser } from './service';
import { homepage } from '../../../package.json';

function* requestUsers(action) {
    const me = yield select(meSlice);
    const { userId, parentUserId } = me || {};
    yield all([put({ type: `${SLICE_NAME}/loading`, payload: true }), put({ type: `${SLICE_NAME}/error`, payload: false })]);
    const response = yield call(fetchUsersPaginated, {
        ...action.payload,
        userId: parentUserId ? parentUserId : userId,
    });
    if (!response.error) {
        yield put({
            type: `${SLICE_NAME}/list`,
            payload: response,
        });
    } else {
        yield put({
            type: `${SLICE_NAME}/error`,
            payload: { message: response.error.description, extraInfo: response.error.extraInfo },
        });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* requestImpersonation(action) {
    yield all([put({ type: `${SLICE_NAME}/loading`, payload: true }), put({ type: `${SLICE_NAME}/impersonationError`, payload: false })]);
    const response = yield call(impersonateUser, {
        ...action.payload,
    });
    if (!response.error) {
        window.location.replace(homepage);
    } else {
        yield put({
            type: `${SLICE_NAME}/impersonationError`,
            payload: { message: response.error.description, extraInfo: response.error.extraInfo },
        });
    }
    yield put({ type: `${SLICE_NAME}/loading`, payload: false });
}

function* userImpersonation() {
    yield takeLatest(`${SLICE_NAME}/requestImpersonation`, requestImpersonation);
}

function* getUsers() {
    yield takeLatest(`${SLICE_NAME}/requestMyApplications`, requestUsers);
    yield takeLatest(`${SLICE_NAME}/requestUsers`, requestUsers);
}

export { getUsers, userImpersonation };
